import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { FaChevronLeft, FaChevronRight, FaStar } from 'react-icons/fa';
import Header from '../components/Header';
import SubscribeBlock from '../components/SubscribeBlock';
import { reviews } from '../data/reviews';
import './WhyLuxTripsPage.css';
import imgLeft from '../assets/why-img-4.png';
import imgCenter from '../assets/why-img-2.png';
import imgRight from '../assets/why-img-3.png';

const features = [
  {
    image: imgLeft,
    title: 'Индивидуальный подход',
    text: 'Каждый маршрут создаётся под ваши интересы, бюджет и темп отдыха.',
  },
  {
    image: imgCenter,
    title: 'Незабываемые впечатления',
    text: 'От пляжного отдыха до эксклюзивных туров — продумываем каждую деталь.',
  },
  {
    image: imgRight,
    title: 'Персонализация поездок',
    text: 'Отели, трансферы, экскурсии и VIP-сервис — всё под ключ.',
  },
];

const stats = [
  { value: '985+', label: 'Организованных туров' },
  { value: '68', label: 'Направлений' },
  { value: '812+', label: 'Довольных клиентов' },
];

const services = [
  'Бронирование отелей и вилл мирового класса',
  'Чартер частных яхт и самолётов',
  'Индивидуальные и групповые маршруты',
  'VIP-сопровождение и персональные гиды',
  'Страховка, визы и трансферы',
];

const NextArrow = ({ onClick }) => (
  <div className="why-reviews-arrow next-arrow" onClick={onClick}><FaChevronRight /></div>
);

const PrevArrow = ({ onClick }) => (
  <div className="why-reviews-arrow prev-arrow" onClick={onClick}><FaChevronLeft /></div>
);

const StarRating = () => (
  <div className="review-stars" aria-label="5 из 5">
    {[...Array(5)].map((_, i) => (
      <FaStar key={i} />
    ))}
  </div>
);

const WhyLuxTripsPage = () => {
  const navigate = useNavigate();

  const reviewSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <main className="why-page">
      <Header />

      <section className="why-hero">
        <div className="page-container">
          <span className="why-badge">О компании</span>
          <h1>Почему Asian Tour</h1>
          <p>
            Мы — команда экспертов по путешествиям, которая делает поездки простыми,
            комфортными и незабываемыми.
          </p>
        </div>
      </section>

      <section className="page-section">
        <div className="page-container">
          <div className="why-features-grid">
            {features.map((item) => (
              <article key={item.title} className="why-feature-card">
                <img src={item.image} alt={item.title} />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="why-stats-section">
        <div className="page-container">
          <div className="why-stats-grid">
            {stats.map((stat) => (
              <div key={stat.label} className="why-stat-card">
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="page-container why-services-block">
          <div className="why-services-text">
            <h2 className="section-title why-services-title">Что мы предлагаем</h2>
            <p className="section-subtitle why-services-subtitle">
              Полный спектр услуг для путешествий любого формата — от пляжного отдыха до премиальных туров.
            </p>
            <ul className="why-services-list">
              {services.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div className="why-cta-row">
              <button className="btn-primary" onClick={() => navigate('/packages')}>
                Смотреть туры
              </button>
              <button className="btn-secondary" onClick={() => navigate('/book')}>
                Оставить заявку
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="why-reviews-section page-section">
        <div className="page-container">
          <h2 className="section-title">Отзывы туристов</h2>
          <p className="section-subtitle">
            Реальные впечатления клиентов, которые путешествовали с Asian Tour.
          </p>

          <div className="why-reviews-carousel">
            <Slider {...reviewSliderSettings}>
              {reviews.map((review) => (
                <div key={review.name}>
                  <article className="why-review-card">
                    <StarRating />
                    <p className="why-review-text">«{review.text}»</p>
                    <div className="why-review-meta">
                      <strong>{review.name}</strong>
                      <span>{review.city} · {review.tour}</span>
                      {review.manager && (
                        <span className="why-review-manager">Менеджер: {review.manager}</span>
                      )}
                    </div>
                  </article>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      <SubscribeBlock />
    </main>
  );
};

export default WhyLuxTripsPage;
